import styled from "styled-components";


export const PasswordContainer = styled.div`
  overflow: hidden;
  background-color: ${props => props.theme.white0};
  position: relative;
  margin: 10px;
  padding: 20px;
  width: 400px;
  border-radius: 10px;
  p {
    margin: 5px;
    color: ${props => props.theme.black2};
    font-size: 12px;
  }
  span {
    display: flex;
    flex-direction: column;
    padding: 5px;
  }
  input {
    border: 1px solid ${props => props.theme.white5};
    right: 0px;
  }
  button {
    margin: 10px 0;
    text-align: center;
    padding: 5px 30px;
    background-color: ${props => props.theme.colorwhite1};
    border-radius: 10px;
    border: 0;
  }
`;